import React, { Component } from "react";
import { Col } from "react-bootstrap";

class Card extends Component {
  // add img props 
  render() {
    return (
      <Col md="4">
        <h2 className="text-center">{this.props.header}</h2>
        <p>{this.props.children}</p>
      </Col>
    );
  }
}

export default Card;